import { render } from "./CostosPersonal.vue?vue&type=template&id=6f6e6ea6&scoped=true"
import script from "./CostosPersonal.vue?vue&type=script&lang=js"
export * from "./CostosPersonal.vue?vue&type=script&lang=js"

import "./CostosPersonal.vue?vue&type=style&index=0&id=6f6e6ea6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f6e6ea6"

export default script